import { useNavigate } from "react-router-dom";
import logo from "../img/logo-clean.png";
import meet from "../img/meet.jpg";
import bg from "../img/bg.png";
import gic from "../img/gic.png";
import partner from "../img/partners.png";
import { useEffect, useRef, useState } from "react";

export default function About () {

    useEffect(() => {
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("fade-in");
                } else {
                    entry.target.classList.remove("fade-in");
                }
            });
        }, {
            threshold: 0.1
        });

        const targetElements = document.querySelectorAll(".fad");
        targetElements.forEach((element) => {
            observer.observe(element);
        });

        return () => {
            observer.disconnect();
        };
    }, []);

    const [scrollY, setScrollY] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
        setScrollY(window.scrollY);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
        window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    let navigate = useNavigate();

    return(
        
        <div className="__next">
            <div className="css-isg"></div>
            <div className="css-sdb epw">
                <div className={scrollY === 0 ? "p-navbar p-navbar-bg-transparent p-navbar-dark p-dark" : "p-navbarbg p-navbar-bg-transparent p-navbar-dark p-dark"}>
                    <div className="p-container p-container-default">
                        <div className="p-container-inner p-navbar-inner-container">
                            <div className="p-navbar-logo-container">
                                <div className="p-navbar-logo-icon css-1nb" onClick={()=>{navigate('/')}}>
                                    <span className="icon p-icon" aria-hidden='false' role="presentation">
                                        <img src={logo} alt="img"className="logo-icon"></img>
                                    </span>
                                </div>
                            </div>
                            <div className="p-navbar-right-on-mobile">
                                <button className="p-navbar-dropdown-toggler reset-button" aria-label="메뉴열기">
                                    <span className="icon p-icon icon--colored p-icon--colored" aria-hidden='false' role="presentation">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="line-icon">
                                            <path fill="#B0B8C1" d="M4.118 6.2h16a1.2 1.2 0 100-2.4h-16a1.2 1.2 0 100 2.4m16 4.6h-16a1.2 1.2 0 100 2.4h16a1.2 1.2 0 100-2.4m0 7h-16a1.2 1.2 0 100 2.4h16a1.2 1.2 0 100-2.4" fill-rule="evenodd"></path>
                                        </svg>
                                    </span>
                                </button>
                            </div>
                            <div className="p-navbar-content" aria-expanded='false' aria-hidden='true'>
                                <ul className="p-navbar-menu"></ul>
                                <ul className="p-navbar-menu">
                                    <li className="p-navbar-item">
                                        <div className="p-navbar-item tag abf" onClick={()=>{navigate('/about')}}>회사소개</div>
                                    </li>
                                    <li className="p-navbar-item">
                                        <div className="p-navbar-item tag abf" onClick={()=>{navigate('/#p')}}>제품소개</div>
                                    </li>
                                    <li className="p-navbar-item">
                                        <div className="p-navbar-item tag abf" onClick={()=>{navigate('/#c')}}>고객문의</div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            

                    <div className="css-13l e1q" style={{backgroundImage: `url(${meet})`}}>
                        <div className="css-14y e1q">
                            <div>
                                <div className="css-3iw e1q">
                                    <span className="css-5wo e1q fad">
                                        열악한 환경에서의 통신대책,  <br></br>
                                        새로운 역사를 만들어 가고 있습니다.
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="css-14u ejx">
                        {/* <div className="css-171 eyb" style={{backgroundImage: `url(${bg})`}}></div>
                        <div className="css-16v eyb"></div> */}
                        <div className="css-q2j eyb">
                            <div>
                                <div className="con fad">
                                    <span className="css-ewd eyb">
                                        Vision
                                    </span>
                                    <span className="css-150 eyb">
                                        기보(주)는 기술보국을 지향하는 회사입니다.  <br></br>
                                        최첨단 고신뢰통신 기술 및 소방관용 통신장비, EO/IR 감시장비와 짐벌 카메라를 연구개발하고 제품화하여 <br></br>
                                        재난상황에서의 안전관리는 물론 국가안보에 기여하고 사회적 의무를 다합니다.<br></br><br></br>
                                        우수한 품질과 기술로 고객만족을 실현하는 것이 <br></br>
                                        기보의 존재 의의 입니다.
                                    </span>
                                </div>
                            </div>                    
                        </div>                
                    </div>

                    <div className="css-4rp e18">
                        <span className="css-3mj e18">기보 조직도</span>
                        <span className="css-g12 e18">새로운 통신모듈을 만들고자 합니다</span>
                        <div className="css-ww2 e18">
                            <div className="css-1h9">
                                <div className="css-aub">
                                    <div className="css-img" style={{backgroundImage: `url(${gic})`}}></div>
                                </div>
                            </div>
                        </div>
                        <div className="css-1n3"></div>
                    </div>
            
                    <div className="css-1wq e1p">
                        <div>
                            <div className="fad">
                                <span className="css-puu e1p">
                                    주요 협력사
                                </span>
                                <div className="css-trs e1p ">
                                    <div className="css-p1w">
                                        <img src={partner} alt="img" className="css-agf e1p"></img>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="css-ygn ers">
                        <div>
                            <div>
                                <div className="css-6kd ers">
                                    <span className="css-aod ers">기보 뉴스</span>
                                </div>
                                <div className="css-1xn ers">
                                    <div>
                                        <div>
                                        <   div className="css-1ve ers">
                                                <div className="css-uv4 ers">
                                                    기보(주)
                                                    <span className="css-1gw ers">2024. 05.</span>
                                                    <span className="css-136 ers">‘2024 국제소방안전박람회’ 참가</span>
                                                </div>
                                            </div>
                                            <div className="css-1ve qew">
                                                <div className="css-uv4 ers">
                                                    기보(주)
                                                    <span className="css-1gw ers">2022. 04.</span>
                                                    <span className="css-136 ers">‘소방대원 생체신호를 활용한 실시간 안전관리 시스템 기술개발’ 사업자 선정</span>
                                                </div>
                                            </div>                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="p-footer p-footer-dark">
                        <div className="p-footer-inner">
                            <div className="p-footer-address">
                                <strong className="p-footer-address-company">기보주식회사</strong>
                                <p className="p-footer-font">사업자 등록번호 : 740-87-02505 | 대표 : 문성철</p>
                                <p className="p-footer-font">본사 : 경기도 시흥시 은계중앙로 247, 103호</p>
                                <p className="p-footer-font">부설연구소 : 경기도 성남시 중원구 둔촌대로 388, 1506호</p>
                                <p className="p-footer-font">연락처 : TEL : 010-5072-9794</p>
                                <p className="p-footer-font">연락처 : FAX : 031-733-7569</p>
                                <a href='mailto:ceo@givo.co.kr'><p className="p-footer-emailfont">ceo@givo.co.kr</p></a>
                                <br></br><br></br><br></br><br></br>
                                <p className="p-footer-font">Copyright © GIVO. All Rights Reserved.</p>                        
                            </div>
                        </div>
                    </div>
            
        </div>
    )

}